<template>
  <section class="fixed w-full h-full top-0 left-0 flex items-center justify-center z-50">
    <div class="bg-black bg-opacity-40 absolute w-full h-full" @click="$emit('close')"/>
    <div class="bg-skin-primary z-50 rounded-2xl w-full pt-3 px-3 pb-7 m-4 shadow-request"
        style="max-width:400px">
        <div class="w-full flex justify-end" >
            <div @click="$emit('close')" class="px-2 cursor-pointer">
                <icon :name="'plus'" :width="30" :height="30" :color="'skin-icon-bg-gray'" class="transform rotate-45" />
            </div>     
        </div>

        <h3 class="text-lg font-bold text-center" v-text="title"></h3>
        
        <div class="max-h-70 overflow-y-auto light-scroll" v-html="content">

        </div>

    </div>
  </section>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    content:{
      type: String,
      default: ''
    }
  },
  components: {
    Icon: () => import("../components/Icon.vue"),
  },
};
</script>